import React from 'react';

const RoleMappingTitle = ({ record }) => {
	return <span>RoleMapping {record && record.fullName ? `"${record.fullName}"` : ''}</span>;
};

export default RoleMappingTitle;
